(function ($, document, window, undefined) {
  window.IPRedirect = {
    init: function (settings) {
      // Assignment
      var self = this;

      self.settings = settings;
      self.redirect = IPRedirect.getCookie("country-region");
      self.messageWrap = $(
        "#location-redirect-message,#location-redirect-popup,#country-selector-popup",
      );

      self.catchAllCountries = settings["redirect_catch_all_countries"];
      self.catchAllURL = settings["redirect_catch_all_url"];
      self.catchAllName = settings["redirect_catch_all_name"];

      self.forceRedirect = settings["redirect_force"] ? true : false;
      self.relativeRedirect = settings["redirect_relative"] ? true : false;
      self.domain = "https://reallyfreegeoip.org/json/?callback=?";
      self.redirects = [];
      self.urlMap = {};
      self.featherlight = $.featherlight;

      // Preparation
      self.loadRedirects(settings);
      self.mapURLs(self.redirects, "::");
      self.redirect =
        self.parseRedirect(self.redirect) ||
        self.readBackup() || { shown: false };
      self.redirect.shown = self.getIsRedirectShown();

      // Initialization successful
      return true;
    },
    run: function () {
      var self = this;

      if (!self.redirect.shown) {
        if (self.forceRedirect) {
          self.makeServerCall(
            self.fetchLocationInfoAndRunCallback,
            self.fetchAndRedirectOnResponse,
          );
        } else {
          self.fetchAndShowRedirect();
          self.bindRedirect();
        }
      }
    },
    loadRedirects: function (settings) {
      var self = this;
      for (var i = 1; i < 11; ++i) {
        var name = "redirect_" + i;

        self.redirects.push(settings[name]);
      }
    },
    mapURLs: function (stringList, splitter) {
      var self = this;

      for (var i = 0; i < stringList.length; ++i) {
        if (stringList[i] && stringList[i] != "") {
          var splitString = stringList[i].split(splitter);

          if (
            splitString[2].indexOf("http://") === -1 &&
            splitString[1].indexOf("https://") === -1
          ) {
            splitString[2] = "http://" + splitString[2];
          }

          self.urlMap[splitString[0]] = {
            name: splitString[1],
            url: splitString[2],
          };
        }
      }

      if (self.catchAllCountries.length > 0) {
        var countries = self.catchAllCountries.split(/[\s,]+/);

        for (var i = 0; i < countries.length; ++i) {
          self.urlMap[countries[i]] = {
            name: self.catchAllName,
            url: self.catchAllURL,
          };
        }
      }

      return self.urlMap;
    },
    getIsRedirectShown: function () {
      return this.redirect.shown === true;
    },
    makeServerCall: function (serverCall, callback) {
      return serverCall(callback);
    },
    fetchLocationInfoAndRunCallback: function (successCallback) {
      var self = IPRedirect;

      $.ajax({
        url: self.domain,
        type: "POST",
        dataType: "jsonp",
        async: false,
        success: successCallback,
        error: successCallback,
      });
    },
    fetchAndShowRedirect: function () {
      var self = IPRedirect;

      if (self.settings.redirect_popup && !Shopify.designMode) {
        self.featherlight($("#country-selector-popup"), {
          closeIcon: "",
          closeOnClick: false,
          closeOnEsc: false,
        });
      } else {
        self.messageWrap.show();
      }
    },
    fetchAndRedirectOnResponse: function (location) {
      var self = IPRedirect;

      self.location = location;

      var localTz = Intl.DateTimeFormat().resolvedOptions().timeZone;
      var country = ct.getCountryForTimezone(localTz);

      location = {
        country_code: country.id,
        country_name: country.name,
      };

      if (self.urlMap[location.country_code].url != null) {
        if (self.relativeRedirect) {
          window.location.assign(
            `${self.urlMap["US"].url}${window.location.pathname}?redirected=true`,
          );
        } else {
          window.location.assign(`${self.urlMap["US"].url}?redirected=true`);
        }
      }
    },
    bindRedirect: function () {
      var self = this;
      var selectedCountry = "";

      $(document).on("change.ipredirect", "#country-select", function () {
        selectedCountry = this.value;
        var hasValue = !!selectedCountry;
        $(".confirm-redirect-btn").prop("disabled", !hasValue);
        $(this).toggleClass("is-placeholder", !hasValue);
      });

      $(document).on("click.ipredirect", ".confirm-redirect-btn", function (e) {
        e.preventDefault();
        e.stopPropagation();

        self.saveRedirect(selectedCountry);

        if (selectedCountry === "US") {
          var targetURL = self.relativeRedirect
            ? self.urlMap["US"].url + window.location.pathname
            : self.urlMap["US"].url;
          window.location.assign(targetURL);
        } else if (window.location.hostname.startsWith("us.")) {
          window.location.assign("https://marielaurechamorel.com" + window.location.pathname);
        } else {
          self.featherlight.close();
        }
      });
    },
    saveRedirect: function (country) {
      var redirect = { shown: true, country: country || "" };
      var endOfDay = new Date();
      endOfDay.setHours(23, 59, 59, 999);
      var encoded = btoa(JSON.stringify(redirect));
      this.setCookie("country-region", encoded, endOfDay);
      // Mirror to localStorage so the choice survives cookie deletion
      // (e.g. GDPR consent apps purging non-whitelisted cookies).
      try {
        localStorage.setItem(
          "country-region",
          JSON.stringify({ value: encoded, expires: endOfDay.getTime() }),
        );
      } catch (e) {}
    },
    parseRedirect: function (raw) {
      if (typeof raw != "string") return null;
      try {
        var parsed = JSON.parse(atob(raw));
        return parsed && typeof parsed == "object" ? parsed : null;
      } catch (e) {
        return null;
      }
    },
    readBackup: function () {
      try {
        var raw = localStorage.getItem("country-region");
        if (!raw) return null;
        var backup = JSON.parse(raw);
        if (!backup || !backup.expires || backup.expires < Date.now()) {
          localStorage.removeItem("country-region");
          return null;
        }
        var parsed = this.parseRedirect(backup.value);
        if (parsed) {
          // Restore the cookie so cross-subdomain redirects keep working.
          this.setCookie("country-region", backup.value, new Date(backup.expires));
        }
        return parsed;
      } catch (e) {
        return null;
      }
    },
    setCookie: function (name, value, expires) {
      document.cookie =
        name +
        "=" +
        encodeURIComponent(value) +
        "; expires=" +
        expires.toUTCString() +
        "; path=/; domain=.marielaurechamorel.com; SameSite=Lax";
    },
    getCookie: function (name) {
      var nameEQ = name + "=";
      var ca = document.cookie.split(";");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i].trim();
        if (c.indexOf(nameEQ) === 0)
          return decodeURIComponent(c.substring(nameEQ.length));
      }
      return null;
    },
  };
})(jQuery, document, window);
